export type ULARECentralStationType = {
  csId: string;
  description: string;
  heartbeatIntervalSeconds: number;
  receiverType: string;
  acknowledgeTimeoutSeconds: number;
  createdAt: string;
  modifiedAt: string;
  enabled: boolean;
  isGlobal: boolean;
  queueCount: number;
  organization: { id: number; displayName: string };
};

export enum HeartbeatStatus {
  INIT = 0,
  SUCCESS = 1,
  ERROR = 2,
}

export type ULARELine = {
  numberDialed: string;
  lineId: string;
};

export type HeartbeatChangeType = {
  id: number;
  oldStatus: HeartbeatStatus;
  newStatus: HeartbeatStatus;
  message: Record<string, unknown>;
  createdAt: string;
  modifiedAt: string;
};

export const heartbeatNames = {
  [HeartbeatStatus.ERROR]: 'offline',
  [HeartbeatStatus.INIT]: 'restarting',
  [HeartbeatStatus.SUCCESS]: 'online',
};

export type CreateULARECentralStationDto = Pick<
  ULARECentralStationType,
  'description' | 'heartbeatIntervalSeconds' | 'enabled' | 'isGlobal'
>;
export type UpdateULARECentralStationDto = CreateULARECentralStationDto;

export type CreateULARELineDto = Pick<ULARELine, 'numberDialed' | 'lineId'>;

export type CreateULAREAllowDto = { ipAddress: string };

export type DeleteULARELineDto = Pick<ULARELine, 'numberDialed' | 'lineId'>;

export type DeleteULAREAllowDto = { ipAddress: string };
